import { useEffect } from 'react'

function useSmoothScroll() {
  useEffect(() => {
    const handleAnchorClick = (event: any) => {
      const targetId = event.currentTarget.getAttribute('href')

      if (targetId && targetId.startsWith('#')) {
        event.preventDefault()
        const targetElement = document.querySelector(targetId)

        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          })
        }
      }
    }

    // Adiciona o evento de clique em todos os links internos
    const anchorLinks = document.querySelectorAll('a[href^="#"]')
    anchorLinks.forEach((link) => {
      link.addEventListener('click', handleAnchorClick)
    })

    // Limpa o evento ao desmontar
    return () => {
      anchorLinks.forEach((link) => {
        link.removeEventListener('click', handleAnchorClick)
      })
    }
  }, [])
}

export default useSmoothScroll
